import {Utils} from "../../../../common/utils";

/**
 * Created by claudio iozzia on 16/03/2017.
 */

// same object used in eDesignSuite
export interface IInputACPreset {
  name: string;
  label?: string;

  VinMin: number;
  VinMax: number;

  VinNomLow: number;
  VinNomHigh: number;

  fLineMin?: number;
  fLineMax?: number;

  fLineNom: number;
}

const VIN_MIN_US = 85;
const VIN_MAX_US = 140;
const VIN_NOM_US = 115;
const FLINE_MIN_US = 57;
const FLINE_MAX_US = 63;
const FLINE_NOM_US = 60;

const VIN_MIN_EU = 185;
const VIN_MAX_EU = 265;
const VIN_NOM_EU = 230;
const FLINE_MIN_EU = 47;
const FLINE_MAX_EU = 53;
const FLINE_NOM_EU = 50;

const VIN_MIN_WD = 90;
const VIN_MAX_WD = VIN_MAX_EU;
const VIN_NOM_H_WD = VIN_NOM_EU;
const VIN_NOM_L_WD = VIN_NOM_US;
const FLINE_MIN_WD = FLINE_MIN_EU;
const FLINE_MAX_WD = FLINE_MAX_US;
const FLINE_NOM_WD = FLINE_NOM_EU;

export const WIDE_RANGE: IInputACPreset = {
  name: 'wide range',
  VinMin: VIN_MIN_WD, VinMax: VIN_MAX_WD,
  fLineMin: FLINE_MIN_WD, fLineMax: FLINE_MAX_WD,

  VinNomLow: VIN_NOM_L_WD, VinNomHigh: VIN_NOM_H_WD,
  fLineNom: FLINE_NOM_WD
};

const EU_RANGE: IInputACPreset = {
  name: '230 V',
  VinMin: VIN_MIN_EU, VinMax: VIN_MAX_EU,
  fLineMin: FLINE_MIN_EU, fLineMax: FLINE_MAX_EU,

  VinNomLow: VIN_NOM_EU, VinNomHigh: VIN_NOM_EU,
  fLineNom: FLINE_NOM_EU
};

const US_RANGE: IInputACPreset = {
  name: '115 V',
  VinMin: VIN_MIN_US, VinMax: VIN_MAX_US,
  fLineMin: FLINE_MIN_US, fLineMax: FLINE_MAX_US,

  VinNomLow: VIN_NOM_US, VinNomHigh: VIN_NOM_US,
  fLineNom: FLINE_NOM_US
};

export const INPUT_AC_PRESET: IInputACPreset[] = [WIDE_RANGE, US_RANGE, EU_RANGE];

export const LINE_FREQUENCY_ADMITTED: number[] = [FLINE_NOM_EU, FLINE_NOM_US];

export function isEuropeRange(min: number = NaN, max: number = NaN): boolean {
  /* check if single current output is defined and inside the bounds */
  const minValue: boolean = Utils.isValueReal(min) && min === VIN_MIN_EU;
  const maxValue: boolean = Utils.isValueReal(max) && max === VIN_MAX_EU;
  return minValue && maxValue;
}

// To check these function
export function isEuropeRangeXFlyback(min: number = NaN): boolean {
  /* check if single current output is defined and inside the bounds */
  const minValue: boolean = !Utils.isValueReal(min) || min >= 150;

  return minValue;
}
